import React from 'react';
import { Phone, Mail, MapPin, Clock, Send, CalendarClock  } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';

export const Contacto = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative h-[50vh] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img 
            src="/fotos/photo-1765020553734-2c050ddb9494.webp" 
            alt="Contacto"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-slate-900/95 to-slate-900/75"></div>
        </div>
        
        <div className="relative z-10 max-w-4xl mx-auto px-4 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            Contacto
          </h1>
          <p className="text-xl text-slate-200 leading-relaxed">
            Estamos aquí para ayudarte. Contáctanos sin compromiso.
          </p>
        </div>
      </section>

      {/* Contact Info Section */}
      <section className="py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Contact Information */}
            <div>
              <h2 className="text-4xl font-bold text-slate-900 mb-8">
                Información de Contacto
              </h2>
              <p className="text-lg text-slate-700 mb-8 leading-relaxed">
                Puedes contactarnos por teléfono, email o visitarnos en nuestra oficina en Laguardia. 
                Estaremos encantados de atenderte y resolver tus dudas.
              </p>

              <div className="space-y-6">
                <Card className="border-2 border-slate-200 hover:border-amber-400 transition-colors">
                  <CardContent className="p-6">
                    <div className="flex items-start gap-4">
                      <div className="w-12 h-12 rounded-lg bg-amber-500 flex items-center justify-center flex-shrink-0">
                        <MapPin className="w-6 h-6 text-white" />
                      </div>
                      <div>
                        <h3 className="font-bold text-slate-900 mb-2">Dirección</h3>
                        <p className="text-slate-700">
                          Calle Mayor 55, 1º<br />
                          01300 Laguardia, Álava<br />
                          País Vasco, España
                        </p>
                      </div>
                    </div>
                  </CardContent>
                </Card>

                <Card className="border-2 border-slate-200 hover:border-amber-400 transition-colors">
                  <CardContent className="p-6">
                    <div className="flex items-start gap-4">
                      <div className="w-12 h-12 rounded-lg bg-slate-900 flex items-center justify-center flex-shrink-0">
                        <Phone className="w-6 h-6 text-white" />
                      </div>
                      <div>
                        <h3 className="font-bold text-slate-900 mb-2">Teléfono</h3>
                        <a href="tel:945600676" className="text-lg text-amber-700 hover:text-amber-800 font-semibold mr-[5px]">
                          945 600 676
                        </a>
                        /
                        <a href="tel:629125142" className="text-lg text-amber-700 hover:text-amber-800 font-semibold ml-[5px]">
                          629 125 142
                        </a>
                        
                        <p className="text-sm text-slate-600 mt-1">
                          Llamadas de lunes a viernes
                        </p>
                      </div>
                    </div>
                  </CardContent>
                </Card>

                <Card className="border-2 border-slate-200 hover:border-amber-400 transition-colors">
                  <CardContent className="p-6">
                    <div className="flex items-start gap-4">
                      <div className="w-12 h-12 rounded-lg bg-slate-900 flex items-center justify-center flex-shrink-0">
                        <Mail className="w-6 h-6 text-white" />
                      </div>
                      <div>
                        <h3 className="font-bold text-slate-900 mb-2">Email</h3>
                        <a href="mailto:info@ayg-asesores.com" className="text-lg text-amber-700 hover:text-amber-800 font-semibold">
                          info@ayg-asesores.com
                        </a>
                        <p className="text-sm text-slate-600 mt-1">
                          Respondemos en menos de 24 horas
                        </p>
                      </div>
                    </div>
                  </CardContent>
                </Card>

                <Card className="border-2 border-slate-200 hover:border-amber-400 transition-colors">
                  <CardContent className="p-6">
                    <div className="flex items-start gap-4">
                      <div className="w-12 h-12 rounded-lg bg-slate-900 flex items-center justify-center flex-shrink-0">
                        <Clock className="w-6 h-6 text-white" />
                      </div>
                      <div>
                        <h3 className="font-bold text-slate-900 mb-2">Horario</h3>
                        <p className="text-slate-700">
                          <span className="font-semibold">Lunes a Viernes:</span><br />
                          8:00 - 16:00
                        </p>
                        <p className="text-sm text-slate-600 mt-2">
                          Posibilidad de cita previa
                        </p>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </div>
            </div>

            {/* Map */}
            <div>
              <h2 className="text-4xl font-bold text-slate-900 mb-8">
                Encuéntranos
              </h2>
              <Card className="border-0 shadow-2xl overflow-hidden">
                <CardContent className="p-0">
                  <div className="w-full h-[600px]">
                    <iframe 
                      // Búsqueda por la dirección, no por coordenadas: el mapa
                      // anterior llevaba un identificador inventado por la
                      // plantilla. Esta forma no necesita clave de Google.
                      // Va como la escribe Google («Mayor Kalea… Araba»): con
                      // «Calle Mayor… Álava» ponía el marcador en otro pueblo.
                      src="https://www.google.com/maps?q=Mayor+Kalea,+55,+01300+Laguardia,+Araba,+Espa%C3%B1a&z=17&output=embed"
                      width="100%"
                      height="100%"
                      style={{ border: 0 }}
                      allowFullScreen=""
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      title="Ubicación Argomaniz y Garcia Asesores"
                    ></iframe>
                  </div>
                </CardContent>
              </Card>
              <p className="text-sm text-slate-600 mt-4 text-center">
                Calle Mayor 55, 1º, 01300 Laguardia, Álava
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold mb-6">
            ¿Listo para Empezar?
          </h2>
          <p className="text-xl text-slate-300 mb-8 leading-relaxed">
            Llámanos o visítanos en nuestra oficina de Laguardia. Te asesoraremos sin compromiso 
            y encontraremos la mejor solución para tus necesidades.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="tel:945600676">
              <button className="bg-amber-500 hover:bg-amber-600 text-white px-8 py-4 text-lg font-bold rounded-xl shadow-2xl transition-all duration-300 flex items-center gap-3">
                <Phone className="w-5 h-5" />
                Llamar Ahora
              </button>
            </a>
            <a href="mailto:info@ayg-asesores.com">
              <button className="bg-white text-slate-900 hover:bg-slate-100 px-8 py-4 text-lg font-bold rounded-xl shadow-2xl transition-all duration-300 flex items-center gap-3">
                <Send className="w-5 h-5" />
                Enviar Email
              </button>
            </a>
            <a href="https://confirmafy.com/argomanizygarcia">
              <button className="bg-green-500 hover:bg-green-600 text-white px-8 py-4 text-lg font-bold rounded-xl shadow-2xl transition-all duration-300 flex items-center gap-3">
                <CalendarClock  className="w-5 h-5" />
                Coge tu cita
              </button>
            </a>
            <img 
              src="/qr.png" 
              alt="Argomaniz y Garcia" 
              className="h-16 w-auto mb-4 max-sm:h-40 max-sm:w-40"
            />
          </div>
        </div>
      </section>
    </div>
  );
};
